import { PreguntasTipoEnum } from "@shared/enums";
import { PreguntaImportador } from "../PreguntaImportador";

export class PreguntaTextImportador extends PreguntaImportador {
    public puedeProcesar(tipoPregunta: PreguntasTipoEnum): boolean {
        return tipoPregunta === PreguntasTipoEnum.TEXT;
    }
}
